<template>
	<div class="keyWordReport">
		<div class="keyWordReport-inspectoscope">
			<h1>网站关键词报告</h1>
			<el-link type="primary" :underline="false" @click="toList">生成记录</el-link>
			<form-combination
				size="small"
				ref="formData"
				:form-data="formData"
				labelWidth="100px"
			></form-combination>
		</div>
		<div class="keyWordReport-inspectoscope">
			<el-button type="primary" @click="getReport" :loading="loading">获取报告</el-button>
		</div>
	</div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import mediafax from '@/backend/services/account/mediafax';
import keywordRanking from '@/backend/services/keywordRanking/keywordRanking';
import { validRequired } from '@/common/elementValid.js';
import { transformdata } from '@/common/util.js';

export default {
	data() {
		return {
			formData: {},
			loading: false,
		};
	},
	components: {
		formCombination,
	},
	watch: {
		'formData.customerId.value'(val) {
			this.formData.serviceId.value = '';
			if (val) this.getMediafaxSubject(val);
		},
	},
	mounted() {
		this.setFormData();
	},
	methods: {
		// 设置表单项
		setFormData() {
			this.formData = {
				customerId: {
					label: '客户名称',
					formType: 'customerSearch',
					placeholder: '请输入',
					controlButton: false,
					value: '',
					rules: [validRequired('此项必填', 'blur')],
				},
				serviceId: {
					label: '域名(服务单)',
					formType: 'sky-select',
					value: '',
					placeholder: '请输入',
					props: {
						label: 'domain',
						value: 'id',
					},
					options: [],
					rules: [validRequired('此项必填', 'blur')],
					setOptionLeftLabel(row) {
						return `${row.domain || '-'}(${row.serviceCode})`;
					},
				},
				type: {
					label: '报告',
					formType: 'sky-radio',
					value: 1,
					options: [
						{
							label: '统计数据',
							value: 1,
						},
						{
							label: '详细数据',
							value: 2,
						},
					],
				},
				emailOne: {
					label: '接收邮箱',
					formType: 'sky-input',
					placeholder: '请输入',
					vSlot: 'append',
					slotProp: '@topsky.com',
					value: '',
					rules: [{ validator: this.emailvalidator, trigger: 'blur', required: true }],
				},
				emailTwo: {
					label: '',
					formType: 'sky-input',
					placeholder: '请输入',
					vSlot: 'append',
					slotProp: '@topsky.com',
					value: '',
					ules: [{ validator: this.emailvalidator, trigger: 'blur', required: true }],
				},
				emailThree: {
					label: '',
					formType: 'sky-input',
					placeholder: '请输入',
					vSlot: 'append',
					slotProp: '@topsky.com',
					value: '',
					ules: [{ validator: this.emailvalidator, trigger: 'blur', required: true }],
				},
			};
		},
		async getMediafaxSubject(val) {
			let res = await mediafax.getMediafaxSubject({
				customerId: val,
			});
			if (res.data) this.formData.serviceId.options = res.data;
		},
		// 表单提交
		getReport() {
			this.$refs.formData.validate(async valid => {
				if (valid) {
					try {
						let res;
						let options = this.formData.serviceId.options;
						let params = transformdata(this.formData);
						let { emailOne, emailTwo, emailThree, serviceId } = params;
						params.domain = options.find(item => item.id === serviceId).domain;
						params.receiver = [emailOne, emailTwo, emailThree]
							.filter(val => val)
							.map(val => {
								return `${val}@topsky.com`;
							});
						delete params.emailOne;
						delete params.emailTwo;
						delete params.emailThree;
						this.loading = true;
						res = await keywordRanking.serpReportTask(params);
						this.loading = false;
						this.$router.push({
							name: 'keyWordReportList',
						});
					} catch (error) {
						this.loading = false;
					}
				}
			});
		},
		// 接收邮箱至少填写一个判断
		emailvalidator(_rule, _value, callback) {
			let params = transformdata(this.formData);
			let { emailOne, emailTwo, emailThree } = params;
			if (emailOne || emailTwo || emailThree) callback();
			else callback(new Error('请至少填写一个接收邮箱'));
		},
		// 跳转列表页
		toList() {
			this.$router.push({ name: 'keyWordReportList' });
		},
	},
};
</script>

<style lang="scss" scoped>
.keyWordReport {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #ffffff;
	padding: 20px;
	position: relative;

	.keyWordReport-inspectoscope {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 500px;

		.el-link {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 15px;
		}

		h5 {
			margin-bottom: 50px;
		}

		::v-deep .form_combination {
			.el-form-item__label {
				padding: 0 10px 0 0 !important;
			}
		}
	}
}
</style>
